import { authContainer } from "assets/jss/material-dashboard-pro-react";

const legalStyle = (theme) => ({
  wrapper: {
    paddingBottom: "50px",
    paddingTop: authContainer.paddingTop,

    paddingLeft: `${authContainer.paddingLg.left}`,
    paddingRight: `${authContainer.paddingSm.right}`,
    [theme.breakpoints.down('lg')]: {
      paddingLeft: `${authContainer.paddingMd.left}`,
      paddingRight: `${authContainer.paddingSm.right}`,
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: `${authContainer.paddingSm.left}`,
      paddingRight: `${authContainer.paddingSm.right}`,
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: `${authContainer.paddingXs.left}`,
      paddingRight: `${authContainer.paddingXs.right}`,
      paddingBottom: "100px",
    },
  },
});

export default legalStyle;
